import { render, staticRenderFns } from "./QuickShortcuts.vue?vue&type=template&id=753de03b&scoped=true&"
import script from "./QuickShortcuts.vue?vue&type=script&lang=js&"
export * from "./QuickShortcuts.vue?vue&type=script&lang=js&"
import style0 from "./QuickShortcuts.vue?vue&type=style&index=0&id=753de03b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753de03b",
  null
  
)

export default component.exports